import { render, staticRenderFns } from "./modalEditarItens.vue?vue&type=template&id=4fbf8d08&scoped=true&"
import script from "./modalEditarItens.vue?vue&type=script&lang=js&"
export * from "./modalEditarItens.vue?vue&type=script&lang=js&"
import style0 from "./modalEditarItens.vue?vue&type=style&index=0&id=4fbf8d08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbf8d08",
  null
  
)

export default component.exports